import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableCell from '@material-ui/core/TableCell';
import styled from 'src/ui/library/styled';
import merge from 'lodash.merge';

const styles = (theme, props) => {
  const s = {
    root: {
      height: '45px',
      border: 'none',
      color: `${theme.colors.eyConfidentGrey}`,
      fontSize: '.9rem',
      fontWeight: 'bold',
      backgroundColor: '#FFF',
      position: 'sticky',
      top: '0px',
      whitespace: 'nowrap',
      zIndex: 98,
      '&:before': {
        content: "''",
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '100%',
        borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
        display: 'block',
        top: '1px',
        zIndex: -1,
      },
    },
    firstColumn: {
      '&:before': {},
    },
    lastColumn: {
      '&:before': {},
    },
    wrapper: {
      display: 'flex',
    },
    displayText: {
      cursor: 'pointer',
      whiteSpace: 'nowrap',
    },
    sort: {
      display: 'inline-block',
      verticalAlign: 'top',
      cursor: 'pointer',
      paddingLeft: '10px',
      paddingTop: '2px',
      height: '10px',
      border: 'none',
      background: 'none',
    },
    noSort: {
      visibility: 'hidden',
    },
    stickyColumn: {
      left: '0px',
      //zIndex: 500,
      //borderBottom: 'solid 1px #eaeaf2',
      //boxShadow: '2px 0 2px 0 rgba(234,234,242,0.01)',
    },
    arrowIcon: {
      width: '8px',
      height: '5px',
      display: 'block',
      paddingBottom: '1px',
      '& svg': {
        width: '8px',
        height: '5px',
        verticalAlign: 'top',
        '& path': {
          fillOpacity: 0.65,
        },
      },
      '&:focus': {
        outline: 'none',
      },
    },
    arrowBottom: {
      marginTop: '5px',
    },
  };
  return props.styleOverrides && props.styleOverrides.TableHeadCell ? merge(s, props.styleOverrides.TableHeadCell) : s;
};

class TableHeadCell extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** Column index value */
    colIndex: PropTypes.number,
    /** Is table sorted by current header? */
    isSortedByCol: PropTypes.bool.isRequired,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
    tableHeadCellProps: PropTypes.object,
  };

  handleSort = (colData, colIndex) => {
    if (colData.sortable) {
      this.props.onChangeSort(colData, colIndex);
    }
  };

  render() {
    const { classes, colData, colIndex, totalColumns, isSortedByCol, tableHeadCellProps = {} } = this.props;

    if (!colData.visible) return null;

    const colClass = classNames({
      [classes.root]: true,
      [classes.firstColumn]: colIndex === 0,
      [classes.lastColumn]: colIndex === totalColumns - 1,
      [classes.stickyColumn]: colData.stickyLeft || false,
      'head-cell': true,
    });

    const sortClass = classNames({
      [classes.sort]: true,
      [classes.noSort]: colData.sortable === false,
    });

    const { sortDirection } = colData;
    let ariaSortedBy = undefined;

    if (isSortedByCol) {
      ariaSortedBy = sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    const titleSortText = sortDirection === 'asc' ? 'descending' : 'ascending';
    return (
      <MuiTableCell
        className={colClass}
        onClick={this.handleSort.bind(null, colData, colIndex)}
        aria-sort={ariaSortedBy}
        {...tableHeadCellProps}
        scope={tableHeadCellProps.scope === null ? undefined : tableHeadCellProps.scope || ''}
        role={tableHeadCellProps.role === null ? undefined : tableHeadCellProps.role || ''}>
        <div className={classes.wrapper}>
          <div className={classes.displayText} aria-hidden="true">
            {colData.displayText}
          </div>
          <button className={sortClass} aria-label={colData.displayText} title={`click to sort by ${titleSortText} order`}>
            <span className={classes.arrowIcon}>
              <svg>
                <path
                  d="m7.54878,4.12621q0,0.20139 -0.13005,0.34856t-0.30802,0.14717l-6.13296,0q-0.17796,0 -0.30802,-0.14717t-0.13005,-0.34856t0.13005,-0.34856l3.06648,-3.47017q0.13005,-0.14717 0.30802,-0.14717t0.30802,0.14717l3.06648,3.47017q0.13005,0.14717 0.13005,0.34856l0,0l0,0z"
                  fill="black"
                />
              </svg>
            </span>
            <span className={classNames(classes.arrowIcon, classes.arrowBottom)}>
              <svg>
                <path
                  d="m 0.53968,0.65604 q 0,-0.20139 0.13005,-0.34856 0.13005,-0.14717 0.30802,-0.14717 l 6.13296,0 q 0.17796,0 0.30802,0.14717 0.13006,0.14717 0.13005,0.34856 -10e-6,0.20139 -0.13005,0.34856 L 4.35225,4.47477 Q 4.2222,4.62194 4.04423,4.62194 q -0.17797,0 -0.30802,-0.14717 L 0.66973,1.0046 Q 0.53968,0.85743 0.53968,0.65604 v 0 z"
                  fill="black"
                />
              </svg>
            </span>
          </button>
        </div>
      </MuiTableCell>
    );
  }
}

export default styled(TableHeadCell)(styles);
